export const NoShowAppointmentSkippedCardIcon = () => {
  return (
    <svg
      width="85"
      height="80"
      viewBox="0 0 85 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="44.7998"
        cy="40"
        r="40"
        fill="#EAF0F0"
      />
      <path
        d="M72.7373 62.0849L72.7362 62.0865C69.9328 66.2425 66.3668 69.8087 62.2094 72.6377L62.209 72.6379C55.6414 77.1147 47.9686 79.5 40 79.5C18.2093 79.5 0.5 61.7666 0.5 39.9751C0.5 18.1844 18.2085 0.5 40 0.5C61.7911 0.5 79.5 18.2338 79.5 39.9751C79.5 47.8966 77.1879 55.5442 72.7373 62.0849Z"
        stroke="#1A1A1A"
      />
      <path
        d="M72.7373 62.0849L72.7362 62.0865C69.9328 66.2425 66.3668 69.8087 62.2094 72.6377L62.209 72.6379C55.6414 77.1147 47.9686 79.5 40 79.5C18.2093 79.5 0.5 61.7666 0.5 39.9751C0.5 18.1844 18.2085 0.5 40 0.5C61.7911 0.5 79.5 18.2338 79.5 39.9751C79.5 47.8966 77.1879 55.5442 72.7373 62.0849Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M72.7373 62.0849L72.7362 62.0865C69.9328 66.2425 66.3668 69.8087 62.2094 72.6377L62.209 72.6379C55.6414 77.1147 47.9686 79.5 40 79.5C18.2093 79.5 0.5 61.7666 0.5 39.9751C0.5 18.1844 18.2085 0.5 40 0.5C61.7911 0.5 79.5 18.2338 79.5 39.9751C79.5 47.8966 77.1879 55.5442 72.7373 62.0849Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M72.7373 62.0849L72.7362 62.0865C69.9328 66.2425 66.3668 69.8087 62.2094 72.6377L62.209 72.6379C55.6414 77.1147 47.9686 79.5 40 79.5C18.2093 79.5 0.5 61.7666 0.5 39.9751C0.5 18.1844 18.2085 0.5 40 0.5C61.7911 0.5 79.5 18.2338 79.5 39.9751C79.5 47.8966 77.1879 55.5442 72.7373 62.0849Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M63.6237 28.1921L27.4332 56.7635L17.909 45.3319"
        stroke="#1A1A1A"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.6237 28.1921L27.4332 56.7635L17.909 45.3319"
        stroke="black"
        stroke-opacity="0.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.6237 28.1921L27.4332 56.7635L17.909 45.3319"
        stroke="black"
        stroke-opacity="0.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.6237 28.1921L27.4332 56.7635L17.909 45.3319"
        stroke="black"
        stroke-opacity="0.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
